/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Samlla
 * Samlla Backend API
 * OpenAPI spec version: 0.1.0
 */
import { createMutation, createQuery } from '@tanstack/svelte-query';
import type {
	CreateMutationOptions,
	CreateMutationResult,
	CreateQueryOptions,
	CreateQueryResult,
	DataTag,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey
} from '@tanstack/svelte-query';

import type {
	BaselineSummaryResponse,
	EmptyTrashApiTrackersTrashEmptyPostParams,
	GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostParams,
	GetTrackerBaselineApiTrackersTrackerIdBaselineGetParams,
	GetTrackerHeatmapApiTrackersTrackerIdHeatmapGetParams,
	GetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetParams,
	GetTrackerStatsApiTrackersTrackerIdStatsGetParams,
	GetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetParams,
	GetTrackersApiTrackersGetParams,
	GetTrackersOverviewApiTrackersOverviewGetParams,
	HTTPValidationError,
	HasEntriesResponse,
	HeatmapResponse,
	MetricCreate,
	MetricRead,
	MetricReorderRequest,
	MetricReorderResponse,
	MetricUpdate,
	PagedTrackerResponse,
	PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteParams,
	RetrospectiveTrendResponse,
	ScheduleCreate,
	ScheduleRead,
	TrackerBaselineResponse,
	TrackerCreate,
	TrackerOverviewResponse,
	TrackerRead,
	TrackerStatsResponse,
	TrackerUpdate,
	TrajectoryProjection,
	UnitConversionCreate,
	UnitConversionRead,
	UnitConversionReorderRequest,
	UnitConversionUpdate,
	UpdateMetricStatisticApiMetricsMetricIdStatisticPatchParams,
	WindowComparisonResponse
} from '.././schemas';

import { customInstance } from '../../orval/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Create a new tracker with its associated metrics for the current user.
 * @summary Create Tracker
 */
export const createTrackerApiTrackersPost = (
	trackerCreate: TrackerCreate,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerRead>(
		{
			url: `/api/trackers`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: trackerCreate,
			signal
		},
		options
	);
};

export const getCreateTrackerApiTrackersPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof createTrackerApiTrackersPost>>,
		TError,
		{ data: TrackerCreate },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof createTrackerApiTrackersPost>>,
	TError,
	{ data: TrackerCreate },
	TContext
> => {
	const mutationKey = ['createTrackerApiTrackersPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createTrackerApiTrackersPost>>,
		{ data: TrackerCreate }
	> = (props) => {
		const { data } = props ?? {};

		return createTrackerApiTrackersPost(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateTrackerApiTrackersPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof createTrackerApiTrackersPost>>
>;
export type CreateTrackerApiTrackersPostMutationBody = TrackerCreate;
export type CreateTrackerApiTrackersPostMutationError = HTTPValidationError;

/**
 * @summary Create Tracker
 */
export const createCreateTrackerApiTrackersPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof createTrackerApiTrackersPost>>,
			TError,
			{ data: TrackerCreate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof createTrackerApiTrackersPost>>,
	TError,
	{ data: TrackerCreate },
	TContext
> => {
	const mutationOptions = getCreateTrackerApiTrackersPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Get a list of all trackers for the current user.
Supports filtering by name, category, hidden_from_quick_add, and sorting.
Returns paginated response for frontend compatibility.
 * @summary Get Trackers
 */
export const getTrackersApiTrackersGet = (
	params?: GetTrackersApiTrackersGetParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<PagedTrackerResponse>(
		{ url: `/api/trackers`, method: 'GET', params, signal },
		options
	);
};

export const getGetTrackersApiTrackersGetQueryKey = (params?: GetTrackersApiTrackersGetParams) => {
	return [`/api/trackers`, ...(params ? [params] : [])] as const;
};

export const getGetTrackersApiTrackersGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrackersApiTrackersGet>>,
	TError = HTTPValidationError
>(
	params?: GetTrackersApiTrackersGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<Awaited<ReturnType<typeof getTrackersApiTrackersGet>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetTrackersApiTrackersGetQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackersApiTrackersGet>>> = ({
		signal
	}) => getTrackersApiTrackersGet(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrackersApiTrackersGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrackersApiTrackersGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTrackersApiTrackersGet>>
>;
export type GetTrackersApiTrackersGetQueryError = HTTPValidationError;

/**
 * @summary Get Trackers
 */

export function createGetTrackersApiTrackersGet<
	TData = Awaited<ReturnType<typeof getTrackersApiTrackersGet>>,
	TError = HTTPValidationError
>(
	params?: GetTrackersApiTrackersGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<Awaited<ReturnType<typeof getTrackersApiTrackersGet>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrackersApiTrackersGetQueryOptions(params, options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Get all archived trackers (not in trash).
 * @summary Get Archived Trackers
 */
export const getArchivedTrackersApiTrackersArchivedGet = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<PagedTrackerResponse>(
		{ url: `/api/trackers/archived`, method: 'GET', signal },
		options
	);
};

export const getGetArchivedTrackersApiTrackersArchivedGetQueryKey = () => {
	return [`/api/trackers/archived`] as const;
};

export const getGetArchivedTrackersApiTrackersArchivedGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getArchivedTrackersApiTrackersArchivedGet>>,
	TError = unknown
>(options?: {
	query?: Partial<
		CreateQueryOptions<
			Awaited<ReturnType<typeof getArchivedTrackersApiTrackersArchivedGet>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetArchivedTrackersApiTrackersArchivedGetQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getArchivedTrackersApiTrackersArchivedGet>>
	> = ({ signal }) => getArchivedTrackersApiTrackersArchivedGet(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getArchivedTrackersApiTrackersArchivedGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetArchivedTrackersApiTrackersArchivedGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getArchivedTrackersApiTrackersArchivedGet>>
>;
export type GetArchivedTrackersApiTrackersArchivedGetQueryError = unknown;

/**
 * @summary Get Archived Trackers
 */

export function createGetArchivedTrackersApiTrackersArchivedGet<
	TData = Awaited<ReturnType<typeof getArchivedTrackersApiTrackersArchivedGet>>,
	TError = unknown
>(
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getArchivedTrackersApiTrackersArchivedGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetArchivedTrackersApiTrackersArchivedGetQueryOptions(options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Get all trashed trackers with deletion countdown.
 * @summary Get Trashed Trackers
 */
export const getTrashedTrackersApiTrackersTrashGet = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<PagedTrackerResponse>(
		{ url: `/api/trackers/trash`, method: 'GET', signal },
		options
	);
};

export const getGetTrashedTrackersApiTrackersTrashGetQueryKey = () => {
	return [`/api/trackers/trash`] as const;
};

export const getGetTrashedTrackersApiTrackersTrashGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrashedTrackersApiTrackersTrashGet>>,
	TError = unknown
>(options?: {
	query?: Partial<
		CreateQueryOptions<
			Awaited<ReturnType<typeof getTrashedTrackersApiTrackersTrashGet>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetTrashedTrackersApiTrackersTrashGetQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTrashedTrackersApiTrackersTrashGet>>
	> = ({ signal }) => getTrashedTrackersApiTrackersTrashGet(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrashedTrackersApiTrackersTrashGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrashedTrackersApiTrackersTrashGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTrashedTrackersApiTrackersTrashGet>>
>;
export type GetTrashedTrackersApiTrackersTrashGetQueryError = unknown;

/**
 * @summary Get Trashed Trackers
 */

export function createGetTrashedTrackersApiTrackersTrashGet<
	TData = Awaited<ReturnType<typeof getTrashedTrackersApiTrackersTrashGet>>,
	TError = unknown
>(
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrashedTrackersApiTrackersTrashGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrashedTrackersApiTrackersTrashGetQueryOptions(options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Get tracker overview for dashboard with aggregated data.

Returns trackers with the most recent entry per tracker and schedule
occurrences. Designed for efficient dashboard rendering.
 * @summary Get Trackers Overview
 */
export const getTrackersOverviewApiTrackersOverviewGet = (
	params?: GetTrackersOverviewApiTrackersOverviewGetParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerOverviewResponse>(
		{ url: `/api/trackers/overview`, method: 'GET', params, signal },
		options
	);
};

export const getGetTrackersOverviewApiTrackersOverviewGetQueryKey = (
	params?: GetTrackersOverviewApiTrackersOverviewGetParams
) => {
	return [`/api/trackers/overview`, ...(params ? [params] : [])] as const;
};

export const getGetTrackersOverviewApiTrackersOverviewGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrackersOverviewApiTrackersOverviewGet>>,
	TError = HTTPValidationError
>(
	params?: GetTrackersOverviewApiTrackersOverviewGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackersOverviewApiTrackersOverviewGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetTrackersOverviewApiTrackersOverviewGetQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTrackersOverviewApiTrackersOverviewGet>>
	> = ({ signal }) => getTrackersOverviewApiTrackersOverviewGet(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrackersOverviewApiTrackersOverviewGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrackersOverviewApiTrackersOverviewGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTrackersOverviewApiTrackersOverviewGet>>
>;
export type GetTrackersOverviewApiTrackersOverviewGetQueryError = HTTPValidationError;

/**
 * @summary Get Trackers Overview
 */

export function createGetTrackersOverviewApiTrackersOverviewGet<
	TData = Awaited<ReturnType<typeof getTrackersOverviewApiTrackersOverviewGet>>,
	TError = HTTPValidationError
>(
	params?: GetTrackersOverviewApiTrackersOverviewGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackersOverviewApiTrackersOverviewGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrackersOverviewApiTrackersOverviewGetQueryOptions(params, options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Get a single tracker by its ID.

Returns the tracker with all metrics. Each metric has an `is_active` field
that clients can use to filter inactive metrics if needed.

Integration trackers (is_integration=True) typically show all metrics.
 * @summary Get Tracker
 */
export const getTrackerApiTrackersTrackerIdGet = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerRead>(
		{ url: `/api/trackers/${trackerId}`, method: 'GET', signal },
		options
	);
};

export const getGetTrackerApiTrackersTrackerIdGetQueryKey = (trackerId?: string) => {
	return [`/api/trackers/${trackerId}`] as const;
};

export const getGetTrackerApiTrackersTrackerIdGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrackerApiTrackersTrackerIdGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerApiTrackersTrackerIdGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetTrackerApiTrackersTrackerIdGetQueryKey(trackerId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackerApiTrackersTrackerIdGet>>> = ({
		signal
	}) => getTrackerApiTrackersTrackerIdGet(trackerId, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!trackerId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrackerApiTrackersTrackerIdGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrackerApiTrackersTrackerIdGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTrackerApiTrackersTrackerIdGet>>
>;
export type GetTrackerApiTrackersTrackerIdGetQueryError = HTTPValidationError;

/**
 * @summary Get Tracker
 */

export function createGetTrackerApiTrackersTrackerIdGet<
	TData = Awaited<ReturnType<typeof getTrackerApiTrackersTrackerIdGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerApiTrackersTrackerIdGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrackerApiTrackersTrackerIdGetQueryOptions(trackerId, options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Update a tracker's name and description.
 * @summary Update Tracker
 */
export const updateTrackerApiTrackersTrackerIdPatch = (
	trackerId: string,
	trackerUpdate: TrackerUpdate,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<TrackerRead>(
		{
			url: `/api/trackers/${trackerId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: trackerUpdate
		},
		options
	);
};

export const getUpdateTrackerApiTrackersTrackerIdPatchMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof updateTrackerApiTrackersTrackerIdPatch>>,
		TError,
		{ trackerId: string; data: TrackerUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof updateTrackerApiTrackersTrackerIdPatch>>,
	TError,
	{ trackerId: string; data: TrackerUpdate },
	TContext
> => {
	const mutationKey = ['updateTrackerApiTrackersTrackerIdPatch'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateTrackerApiTrackersTrackerIdPatch>>,
		{ trackerId: string; data: TrackerUpdate }
	> = (props) => {
		const { trackerId, data } = props ?? {};

		return updateTrackerApiTrackersTrackerIdPatch(trackerId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateTrackerApiTrackersTrackerIdPatchMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateTrackerApiTrackersTrackerIdPatch>>
>;
export type UpdateTrackerApiTrackersTrackerIdPatchMutationBody = TrackerUpdate;
export type UpdateTrackerApiTrackersTrackerIdPatchMutationError = HTTPValidationError;

/**
 * @summary Update Tracker
 */
export const createUpdateTrackerApiTrackersTrackerIdPatch = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof updateTrackerApiTrackersTrackerIdPatch>>,
			TError,
			{ trackerId: string; data: TrackerUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof updateTrackerApiTrackersTrackerIdPatch>>,
	TError,
	{ trackerId: string; data: TrackerUpdate },
	TContext
> => {
	const mutationOptions = getUpdateTrackerApiTrackersTrackerIdPatchMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Delete a tracker (moves to trash in new implementation).
For backward compatibility, this now moves the tracker to trash instead of permanent deletion.
 * @summary Delete Tracker
 */
export const deleteTrackerApiTrackersTrackerIdDelete = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<void>({ url: `/api/trackers/${trackerId}`, method: 'DELETE' }, options);
};

export const getDeleteTrackerApiTrackersTrackerIdDeleteMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof deleteTrackerApiTrackersTrackerIdDelete>>,
		TError,
		{ trackerId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof deleteTrackerApiTrackersTrackerIdDelete>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationKey = ['deleteTrackerApiTrackersTrackerIdDelete'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteTrackerApiTrackersTrackerIdDelete>>,
		{ trackerId: string }
	> = (props) => {
		const { trackerId } = props ?? {};

		return deleteTrackerApiTrackersTrackerIdDelete(trackerId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteTrackerApiTrackersTrackerIdDeleteMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteTrackerApiTrackersTrackerIdDelete>>
>;

export type DeleteTrackerApiTrackersTrackerIdDeleteMutationError = HTTPValidationError;

/**
 * @summary Delete Tracker
 */
export const createDeleteTrackerApiTrackersTrackerIdDelete = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof deleteTrackerApiTrackersTrackerIdDelete>>,
			TError,
			{ trackerId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof deleteTrackerApiTrackersTrackerIdDelete>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationOptions = getDeleteTrackerApiTrackersTrackerIdDeleteMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Get daily aggregated heatmap data for a tracker.

Returns a GitHub-style heatmap with daily values aggregated by metric type:
- NUMBER: sum of values per day (or daily delta for ODOMETER mode)
- DURATION: total duration per day (in seconds)
- SCALE: average of scale values per day
- BOOLEAN: count of entries per day

For ODOMETER tracking mode:
- Shows daily delta: last_value(today) - last_value(previous_day_with_entry)
- First day with entry has delta=0
- Days without entries have value=0 and don't update the previous value reference
- Negative deltas are allowed (e.g., corrections/resets)

For multi-metric trackers, metric_id is required.
 * @summary Get Tracker Heatmap
 */
export const getTrackerHeatmapApiTrackersTrackerIdHeatmapGet = (
	trackerId: string,
	params?: GetTrackerHeatmapApiTrackersTrackerIdHeatmapGetParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<HeatmapResponse>(
		{ url: `/api/trackers/${trackerId}/heatmap`, method: 'GET', params, signal },
		options
	);
};

export const getGetTrackerHeatmapApiTrackersTrackerIdHeatmapGetQueryKey = (
	trackerId?: string,
	params?: GetTrackerHeatmapApiTrackersTrackerIdHeatmapGetParams
) => {
	return [`/api/trackers/${trackerId}/heatmap`, ...(params ? [params] : [])] as const;
};

export const getGetTrackerHeatmapApiTrackersTrackerIdHeatmapGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrackerHeatmapApiTrackersTrackerIdHeatmapGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params?: GetTrackerHeatmapApiTrackersTrackerIdHeatmapGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerHeatmapApiTrackersTrackerIdHeatmapGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetTrackerHeatmapApiTrackersTrackerIdHeatmapGetQueryKey(trackerId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTrackerHeatmapApiTrackersTrackerIdHeatmapGet>>
	> = ({ signal }) =>
		getTrackerHeatmapApiTrackersTrackerIdHeatmapGet(trackerId, params, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!trackerId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrackerHeatmapApiTrackersTrackerIdHeatmapGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrackerHeatmapApiTrackersTrackerIdHeatmapGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTrackerHeatmapApiTrackersTrackerIdHeatmapGet>>
>;
export type GetTrackerHeatmapApiTrackersTrackerIdHeatmapGetQueryError = HTTPValidationError;

/**
 * @summary Get Tracker Heatmap
 */

export function createGetTrackerHeatmapApiTrackersTrackerIdHeatmapGet<
	TData = Awaited<ReturnType<typeof getTrackerHeatmapApiTrackersTrackerIdHeatmapGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params?: GetTrackerHeatmapApiTrackersTrackerIdHeatmapGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerHeatmapApiTrackersTrackerIdHeatmapGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrackerHeatmapApiTrackersTrackerIdHeatmapGetQueryOptions(
		trackerId,
		params,
		options
	);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Get aggregated statistics for all tracker metrics over a specified time period.

Returns summary statistics (sum, avg, min, max, count) and time-grouped data points for each metric.
Missing time buckets are filled with zero values for chart continuity.

Time grouping options:
- day: Daily aggregation
- week: Weekly aggregation (starting Monday)
- month: Monthly aggregation (first day of month)
- year: Yearly aggregation (January 1st)

Aggregations (optional query parameters):
- Use aggregation_{metric_id}=type format for per-metric aggregation
- Example: aggregation_550e8400-e29b-41d4-a716-446655440000=avg
- Supported types: sum, avg, max, min, count, count_true, count_false, count_all
  (validated per metric_type via MetricAggregator, SAM-816)
- If not provided, the metric's default_statistic drives the aggregation
- Invalid/disallowed aggregation types fall back to the metric's
  default_statistic with a warning

Example usage:
- Last 7 days with daily grouping
- Last 30 days with weekly grouping
- Custom aggregation per metric: ?aggregation_{uuid1}=avg&aggregation_{uuid2}=max
 * @summary Get Tracker Stats
 */
export const getTrackerStatsApiTrackersTrackerIdStatsGet = (
	trackerId: string,
	params: GetTrackerStatsApiTrackersTrackerIdStatsGetParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerStatsResponse>(
		{ url: `/api/trackers/${trackerId}/stats`, method: 'GET', params, signal },
		options
	);
};

export const getGetTrackerStatsApiTrackersTrackerIdStatsGetQueryKey = (
	trackerId?: string,
	params?: GetTrackerStatsApiTrackersTrackerIdStatsGetParams
) => {
	return [`/api/trackers/${trackerId}/stats`, ...(params ? [params] : [])] as const;
};

export const getGetTrackerStatsApiTrackersTrackerIdStatsGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrackerStatsApiTrackersTrackerIdStatsGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params: GetTrackerStatsApiTrackersTrackerIdStatsGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerStatsApiTrackersTrackerIdStatsGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetTrackerStatsApiTrackersTrackerIdStatsGetQueryKey(trackerId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTrackerStatsApiTrackersTrackerIdStatsGet>>
	> = ({ signal }) =>
		getTrackerStatsApiTrackersTrackerIdStatsGet(trackerId, params, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!trackerId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrackerStatsApiTrackersTrackerIdStatsGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrackerStatsApiTrackersTrackerIdStatsGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTrackerStatsApiTrackersTrackerIdStatsGet>>
>;
export type GetTrackerStatsApiTrackersTrackerIdStatsGetQueryError = HTTPValidationError;

/**
 * @summary Get Tracker Stats
 */

export function createGetTrackerStatsApiTrackersTrackerIdStatsGet<
	TData = Awaited<ReturnType<typeof getTrackerStatsApiTrackersTrackerIdStatsGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params: GetTrackerStatsApiTrackersTrackerIdStatsGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerStatsApiTrackersTrackerIdStatsGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrackerStatsApiTrackersTrackerIdStatsGetQueryOptions(
		trackerId,
		params,
		options
	);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Baseline + window payload for the tracker's 'Where I am' tab (SAM-756).
 * @summary Get Tracker Baseline
 */
export const getTrackerBaselineApiTrackersTrackerIdBaselineGet = (
	trackerId: string,
	params?: GetTrackerBaselineApiTrackersTrackerIdBaselineGetParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerBaselineResponse>(
		{ url: `/api/trackers/${trackerId}/baseline`, method: 'GET', params, signal },
		options
	);
};

export const getGetTrackerBaselineApiTrackersTrackerIdBaselineGetQueryKey = (
	trackerId?: string,
	params?: GetTrackerBaselineApiTrackersTrackerIdBaselineGetParams
) => {
	return [`/api/trackers/${trackerId}/baseline`, ...(params ? [params] : [])] as const;
};

export const getGetTrackerBaselineApiTrackersTrackerIdBaselineGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrackerBaselineApiTrackersTrackerIdBaselineGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params?: GetTrackerBaselineApiTrackersTrackerIdBaselineGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerBaselineApiTrackersTrackerIdBaselineGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetTrackerBaselineApiTrackersTrackerIdBaselineGetQueryKey(trackerId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTrackerBaselineApiTrackersTrackerIdBaselineGet>>
	> = ({ signal }) =>
		getTrackerBaselineApiTrackersTrackerIdBaselineGet(trackerId, params, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!trackerId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrackerBaselineApiTrackersTrackerIdBaselineGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrackerBaselineApiTrackersTrackerIdBaselineGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTrackerBaselineApiTrackersTrackerIdBaselineGet>>
>;
export type GetTrackerBaselineApiTrackersTrackerIdBaselineGetQueryError = HTTPValidationError;

/**
 * @summary Get Tracker Baseline
 */

export function createGetTrackerBaselineApiTrackersTrackerIdBaselineGet<
	TData = Awaited<ReturnType<typeof getTrackerBaselineApiTrackersTrackerIdBaselineGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params?: GetTrackerBaselineApiTrackersTrackerIdBaselineGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerBaselineApiTrackersTrackerIdBaselineGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrackerBaselineApiTrackersTrackerIdBaselineGetQueryOptions(
		trackerId,
		params,
		options
	);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Every available window side by side, as nested spans ending today (SAM-914).

No query parameters on purpose: the horizons come from the tracker's own
progressive availability, and the windows always end today — an offset here
would invite reading the rows as disjoint periods, which they are not.
 * @summary Get Tracker Window Comparison
 */
export const getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<WindowComparisonResponse>(
		{ url: `/api/trackers/${trackerId}/window-comparison`, method: 'GET', signal },
		options
	);
};

export const getGetTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGetQueryKey = (
	trackerId?: string
) => {
	return [`/api/trackers/${trackerId}/window-comparison`] as const;
};

export const getGetTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGetQueryOptions = <
	TData = Awaited<
		ReturnType<typeof getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet>
	>,
	TError = HTTPValidationError
>(
	trackerId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<
					ReturnType<typeof getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGetQueryKey(trackerId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet>>
	> = ({ signal }) =>
		getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet(
			trackerId,
			requestOptions,
			signal
		);

	return { queryKey, queryFn, enabled: !!trackerId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGetQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet>>
	>;
export type GetTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGetQueryError =
	HTTPValidationError;

/**
 * @summary Get Tracker Window Comparison
 */

export function createGetTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet<
	TData = Awaited<
		ReturnType<typeof getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet>
	>,
	TError = HTTPValidationError
>(
	trackerId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<
					ReturnType<typeof getTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGet>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions =
		getGetTrackerWindowComparisonApiTrackersTrackerIdWindowComparisonGetQueryOptions(
			trackerId,
			options
		);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Project the current week/month from the mature observed baseline.
 * @summary Get Tracker Trajectory
 */
export const getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet = (
	trackerId: string,
	params?: GetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrajectoryProjection>(
		{ url: `/api/trackers/${trackerId}/trajectory`, method: 'GET', params, signal },
		options
	);
};

export const getGetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetQueryKey = (
	trackerId?: string,
	params?: GetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetParams
) => {
	return [`/api/trackers/${trackerId}/trajectory`, ...(params ? [params] : [])] as const;
};

export const getGetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params?: GetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetQueryKey(trackerId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet>>
	> = ({ signal }) =>
		getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet(
			trackerId,
			params,
			requestOptions,
			signal
		);

	return { queryKey, queryFn, enabled: !!trackerId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet>>
>;
export type GetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetQueryError = HTTPValidationError;

/**
 * @summary Get Tracker Trajectory
 */

export function createGetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet<
	TData = Awaited<ReturnType<typeof getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params?: GetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getTrackerTrajectoryApiTrackersTrackerIdTrajectoryGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetTrackerTrajectoryApiTrackersTrackerIdTrajectoryGetQueryOptions(
		trackerId,
		params,
		options
	);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Return a completed-bucket Theil–Sen trend without forecasting.
 * @summary Get Tracker Retrospective Trend
 */
export const getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet = (
	trackerId: string,
	params?: GetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<RetrospectiveTrendResponse>(
		{ url: `/api/trackers/${trackerId}/retrospective-trend`, method: 'GET', params, signal },
		options
	);
};

export const getGetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetQueryKey = (
	trackerId?: string,
	params?: GetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetParams
) => {
	return [`/api/trackers/${trackerId}/retrospective-trend`, ...(params ? [params] : [])] as const;
};

export const getGetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet>
		>,
		TError = HTTPValidationError
	>(
		trackerId: string,
		params?: GetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetParams,
		options?: {
			query?: Partial<
				CreateQueryOptions<
					Awaited<
						ReturnType<typeof getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet>
					>,
					TError,
					TData
				>
			>;
			request?: SecondParameter<typeof customInstance>;
		}
	) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getGetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetQueryKey(
				trackerId,
				params
			);

		const queryFn: QueryFunction<
			Awaited<
				ReturnType<typeof getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet>
			>
		> = ({ signal }) =>
			getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet(
				trackerId,
				params,
				requestOptions,
				signal
			);

		return { queryKey, queryFn, enabled: !!trackerId, ...queryOptions } as CreateQueryOptions<
			Awaited<
				ReturnType<typeof getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet>
			>,
			TError,
			TData
		> & { queryKey: DataTag<QueryKey, TData, TError> };
	};

export type GetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetQueryResult =
	NonNullable<
		Awaited<
			ReturnType<typeof getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet>
		>
	>;
export type GetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetQueryError =
	HTTPValidationError;

/**
 * @summary Get Tracker Retrospective Trend
 */

export function createGetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet<
	TData = Awaited<
		ReturnType<typeof getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet>
	>,
	TError = HTTPValidationError
>(
	trackerId: string,
	params?: GetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<
					ReturnType<typeof getTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGet>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions =
		getGetTrackerRetrospectiveTrendApiTrackersTrackerIdRetrospectiveTrendGetQueryOptions(
			trackerId,
			params,
			options
		);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Update the default statistic display for a metric.
 * @summary Update Metric Statistic
 */
export const updateMetricStatisticApiMetricsMetricIdStatisticPatch = (
	metricId: string,
	params: UpdateMetricStatisticApiMetricsMetricIdStatisticPatchParams,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<MetricRead>(
		{ url: `/api/metrics/${metricId}/statistic`, method: 'PATCH', params },
		options
	);
};

export const getUpdateMetricStatisticApiMetricsMetricIdStatisticPatchMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof updateMetricStatisticApiMetricsMetricIdStatisticPatch>>,
		TError,
		{ metricId: string; params: UpdateMetricStatisticApiMetricsMetricIdStatisticPatchParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof updateMetricStatisticApiMetricsMetricIdStatisticPatch>>,
	TError,
	{ metricId: string; params: UpdateMetricStatisticApiMetricsMetricIdStatisticPatchParams },
	TContext
> => {
	const mutationKey = ['updateMetricStatisticApiMetricsMetricIdStatisticPatch'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateMetricStatisticApiMetricsMetricIdStatisticPatch>>,
		{ metricId: string; params: UpdateMetricStatisticApiMetricsMetricIdStatisticPatchParams }
	> = (props) => {
		const { metricId, params } = props ?? {};

		return updateMetricStatisticApiMetricsMetricIdStatisticPatch(metricId, params, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateMetricStatisticApiMetricsMetricIdStatisticPatchMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateMetricStatisticApiMetricsMetricIdStatisticPatch>>
>;

export type UpdateMetricStatisticApiMetricsMetricIdStatisticPatchMutationError =
	HTTPValidationError;

/**
 * @summary Update Metric Statistic
 */
export const createUpdateMetricStatisticApiMetricsMetricIdStatisticPatch = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof updateMetricStatisticApiMetricsMetricIdStatisticPatch>>,
			TError,
			{ metricId: string; params: UpdateMetricStatisticApiMetricsMetricIdStatisticPatchParams },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof updateMetricStatisticApiMetricsMetricIdStatisticPatch>>,
	TError,
	{ metricId: string; params: UpdateMetricStatisticApiMetricsMetricIdStatisticPatchParams },
	TContext
> => {
	const mutationOptions =
		getUpdateMetricStatisticApiMetricsMetricIdStatisticPatchMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Reorder a tracker's metrics. SAM-465.

Body: ``{"metric_ids": [uuid, ...]}`` — full list in target order.
Position in the list = canonical ``order_index`` (0..N-1).
 * @summary Reorder Metrics
 */
export const reorderMetricsApiTrackersTrackerIdMetricsReorderPatch = (
	trackerId: string,
	metricReorderRequest: MetricReorderRequest,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<MetricReorderResponse>(
		{
			url: `/api/trackers/${trackerId}/metrics/reorder`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: metricReorderRequest
		},
		options
	);
};

export const getReorderMetricsApiTrackersTrackerIdMetricsReorderPatchMutationOptions = <
	TError = void,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof reorderMetricsApiTrackersTrackerIdMetricsReorderPatch>>,
		TError,
		{ trackerId: string; data: MetricReorderRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof reorderMetricsApiTrackersTrackerIdMetricsReorderPatch>>,
	TError,
	{ trackerId: string; data: MetricReorderRequest },
	TContext
> => {
	const mutationKey = ['reorderMetricsApiTrackersTrackerIdMetricsReorderPatch'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof reorderMetricsApiTrackersTrackerIdMetricsReorderPatch>>,
		{ trackerId: string; data: MetricReorderRequest }
	> = (props) => {
		const { trackerId, data } = props ?? {};

		return reorderMetricsApiTrackersTrackerIdMetricsReorderPatch(trackerId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReorderMetricsApiTrackersTrackerIdMetricsReorderPatchMutationResult = NonNullable<
	Awaited<ReturnType<typeof reorderMetricsApiTrackersTrackerIdMetricsReorderPatch>>
>;
export type ReorderMetricsApiTrackersTrackerIdMetricsReorderPatchMutationBody =
	MetricReorderRequest;
export type ReorderMetricsApiTrackersTrackerIdMetricsReorderPatchMutationError = void;

/**
 * @summary Reorder Metrics
 */
export const createReorderMetricsApiTrackersTrackerIdMetricsReorderPatch = <
	TError = void,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof reorderMetricsApiTrackersTrackerIdMetricsReorderPatch>>,
			TError,
			{ trackerId: string; data: MetricReorderRequest },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof reorderMetricsApiTrackersTrackerIdMetricsReorderPatch>>,
	TError,
	{ trackerId: string; data: MetricReorderRequest },
	TContext
> => {
	const mutationOptions =
		getReorderMetricsApiTrackersTrackerIdMetricsReorderPatchMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Keep a tracker active and suppress its nudge for one full threshold.
 * @summary Dismiss Tracker Inactivity Nudge
 */
export const dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerRead>(
		{ url: `/api/trackers/${trackerId}/inactivity-nudge/dismiss`, method: 'POST', signal },
		options
	);
};

export const getDismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPostMutationOptions =
	<TError = HTTPValidationError, TContext = unknown>(options?: {
		mutation?: CreateMutationOptions<
			Awaited<
				ReturnType<
					typeof dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost
				>
			>,
			TError,
			{ trackerId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): CreateMutationOptions<
		Awaited<
			ReturnType<typeof dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost>
		>,
		TError,
		{ trackerId: string },
		TContext
	> => {
		const mutationKey = [
			'dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost'
		];
		const { mutation: mutationOptions, request: requestOptions } = options
			? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
				? options
				: { ...options, mutation: { ...options.mutation, mutationKey } }
			: { mutation: { mutationKey }, request: undefined };

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<
					typeof dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost
				>
			>,
			{ trackerId: string }
		> = (props) => {
			const { trackerId } = props ?? {};

			return dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost(
				trackerId,
				requestOptions
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type DismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPostMutationResult =
	NonNullable<
		Awaited<
			ReturnType<typeof dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost>
		>
	>;

export type DismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPostMutationError =
	HTTPValidationError;

/**
 * @summary Dismiss Tracker Inactivity Nudge
 */
export const createDismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<
				ReturnType<
					typeof dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost
				>
			>,
			TError,
			{ trackerId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<
		ReturnType<typeof dismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPost>
	>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationOptions =
		getDismissTrackerInactivityNudgeApiTrackersTrackerIdInactivityNudgeDismissPostMutationOptions(
			options
		);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Archive a tracker. Sets archived_at timestamp.
Archived trackers are hidden from main views but can be restored.
 * @summary Archive Tracker
 */
export const archiveTrackerApiTrackersTrackerIdArchivePost = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerRead>(
		{ url: `/api/trackers/${trackerId}/archive`, method: 'POST', signal },
		options
	);
};

export const getArchiveTrackerApiTrackersTrackerIdArchivePostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof archiveTrackerApiTrackersTrackerIdArchivePost>>,
		TError,
		{ trackerId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof archiveTrackerApiTrackersTrackerIdArchivePost>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationKey = ['archiveTrackerApiTrackersTrackerIdArchivePost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof archiveTrackerApiTrackersTrackerIdArchivePost>>,
		{ trackerId: string }
	> = (props) => {
		const { trackerId } = props ?? {};

		return archiveTrackerApiTrackersTrackerIdArchivePost(trackerId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ArchiveTrackerApiTrackersTrackerIdArchivePostMutationResult = NonNullable<
	Awaited<ReturnType<typeof archiveTrackerApiTrackersTrackerIdArchivePost>>
>;

export type ArchiveTrackerApiTrackersTrackerIdArchivePostMutationError = HTTPValidationError;

/**
 * @summary Archive Tracker
 */
export const createArchiveTrackerApiTrackersTrackerIdArchivePost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof archiveTrackerApiTrackersTrackerIdArchivePost>>,
			TError,
			{ trackerId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof archiveTrackerApiTrackersTrackerIdArchivePost>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationOptions = getArchiveTrackerApiTrackersTrackerIdArchivePostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Unarchive a tracker. Clears archived_at timestamp.
 * @summary Unarchive Tracker
 */
export const unarchiveTrackerApiTrackersTrackerIdUnarchivePost = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerRead>(
		{ url: `/api/trackers/${trackerId}/unarchive`, method: 'POST', signal },
		options
	);
};

export const getUnarchiveTrackerApiTrackersTrackerIdUnarchivePostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof unarchiveTrackerApiTrackersTrackerIdUnarchivePost>>,
		TError,
		{ trackerId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof unarchiveTrackerApiTrackersTrackerIdUnarchivePost>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationKey = ['unarchiveTrackerApiTrackersTrackerIdUnarchivePost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof unarchiveTrackerApiTrackersTrackerIdUnarchivePost>>,
		{ trackerId: string }
	> = (props) => {
		const { trackerId } = props ?? {};

		return unarchiveTrackerApiTrackersTrackerIdUnarchivePost(trackerId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UnarchiveTrackerApiTrackersTrackerIdUnarchivePostMutationResult = NonNullable<
	Awaited<ReturnType<typeof unarchiveTrackerApiTrackersTrackerIdUnarchivePost>>
>;

export type UnarchiveTrackerApiTrackersTrackerIdUnarchivePostMutationError = HTTPValidationError;

/**
 * @summary Unarchive Tracker
 */
export const createUnarchiveTrackerApiTrackersTrackerIdUnarchivePost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof unarchiveTrackerApiTrackersTrackerIdUnarchivePost>>,
			TError,
			{ trackerId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof unarchiveTrackerApiTrackersTrackerIdUnarchivePost>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationOptions =
		getUnarchiveTrackerApiTrackersTrackerIdUnarchivePostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Move tracker to trash. Sets deleted_at timestamp and schedules deletion in 30 days.
Trashed trackers can be restored within 30 days.
 * @summary Trash Tracker
 */
export const trashTrackerApiTrackersTrackerIdTrashPost = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerRead>(
		{ url: `/api/trackers/${trackerId}/trash`, method: 'POST', signal },
		options
	);
};

export const getTrashTrackerApiTrackersTrackerIdTrashPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof trashTrackerApiTrackersTrackerIdTrashPost>>,
		TError,
		{ trackerId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof trashTrackerApiTrackersTrackerIdTrashPost>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationKey = ['trashTrackerApiTrackersTrackerIdTrashPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof trashTrackerApiTrackersTrackerIdTrashPost>>,
		{ trackerId: string }
	> = (props) => {
		const { trackerId } = props ?? {};

		return trashTrackerApiTrackersTrackerIdTrashPost(trackerId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type TrashTrackerApiTrackersTrackerIdTrashPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof trashTrackerApiTrackersTrackerIdTrashPost>>
>;

export type TrashTrackerApiTrackersTrackerIdTrashPostMutationError = HTTPValidationError;

/**
 * @summary Trash Tracker
 */
export const createTrashTrackerApiTrackersTrackerIdTrashPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof trashTrackerApiTrackersTrackerIdTrashPost>>,
			TError,
			{ trackerId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof trashTrackerApiTrackersTrackerIdTrashPost>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationOptions = getTrashTrackerApiTrackersTrackerIdTrashPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Restore tracker from trash. Clears deleted_at and deletion_scheduled_at timestamps.
 * @summary Restore Tracker
 */
export const restoreTrackerApiTrackersTrackerIdRestorePost = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<TrackerRead>(
		{ url: `/api/trackers/${trackerId}/restore`, method: 'POST', signal },
		options
	);
};

export const getRestoreTrackerApiTrackersTrackerIdRestorePostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof restoreTrackerApiTrackersTrackerIdRestorePost>>,
		TError,
		{ trackerId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof restoreTrackerApiTrackersTrackerIdRestorePost>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationKey = ['restoreTrackerApiTrackersTrackerIdRestorePost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof restoreTrackerApiTrackersTrackerIdRestorePost>>,
		{ trackerId: string }
	> = (props) => {
		const { trackerId } = props ?? {};

		return restoreTrackerApiTrackersTrackerIdRestorePost(trackerId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type RestoreTrackerApiTrackersTrackerIdRestorePostMutationResult = NonNullable<
	Awaited<ReturnType<typeof restoreTrackerApiTrackersTrackerIdRestorePost>>
>;

export type RestoreTrackerApiTrackersTrackerIdRestorePostMutationError = HTTPValidationError;

/**
 * @summary Restore Tracker
 */
export const createRestoreTrackerApiTrackersTrackerIdRestorePost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof restoreTrackerApiTrackersTrackerIdRestorePost>>,
			TError,
			{ trackerId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof restoreTrackerApiTrackersTrackerIdRestorePost>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationOptions = getRestoreTrackerApiTrackersTrackerIdRestorePostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Permanently delete a tracker. This action cannot be undone.
Requires confirmation parameter and tracker must be in trash.
 * @summary Permanent Delete Tracker
 */
export const permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete = (
	trackerId: string,
	params?: PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteParams,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<void>(
		{ url: `/api/trackers/${trackerId}/permanent`, method: 'DELETE', params },
		options
	);
};

export const getPermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete>>,
		TError,
		{ trackerId: string; params?: PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete>>,
	TError,
	{ trackerId: string; params?: PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteParams },
	TContext
> => {
	const mutationKey = ['permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete>>,
		{ trackerId: string; params?: PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteParams }
	> = (props) => {
		const { trackerId, params } = props ?? {};

		return permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete(
			trackerId,
			params,
			requestOptions
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteMutationResult = NonNullable<
	Awaited<ReturnType<typeof permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete>>
>;

export type PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteMutationError =
	HTTPValidationError;

/**
 * @summary Permanent Delete Tracker
 */
export const createPermanentDeleteTrackerApiTrackersTrackerIdPermanentDelete = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete>>,
			TError,
			{
				trackerId: string;
				params?: PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteParams;
			},
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof permanentDeleteTrackerApiTrackersTrackerIdPermanentDelete>>,
	TError,
	{ trackerId: string; params?: PermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteParams },
	TContext
> => {
	const mutationOptions =
		getPermanentDeleteTrackerApiTrackersTrackerIdPermanentDeleteMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Permanently delete all trashed trackers. This action cannot be undone.
 * @summary Empty Trash
 */
export const emptyTrashApiTrackersTrashEmptyPost = (
	params?: EmptyTrashApiTrackersTrashEmptyPostParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<unknown>(
		{ url: `/api/trackers/trash/empty`, method: 'POST', params, signal },
		options
	);
};

export const getEmptyTrashApiTrackersTrashEmptyPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof emptyTrashApiTrackersTrashEmptyPost>>,
		TError,
		{ params?: EmptyTrashApiTrackersTrashEmptyPostParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof emptyTrashApiTrackersTrashEmptyPost>>,
	TError,
	{ params?: EmptyTrashApiTrackersTrashEmptyPostParams },
	TContext
> => {
	const mutationKey = ['emptyTrashApiTrackersTrashEmptyPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof emptyTrashApiTrackersTrashEmptyPost>>,
		{ params?: EmptyTrashApiTrackersTrashEmptyPostParams }
	> = (props) => {
		const { params } = props ?? {};

		return emptyTrashApiTrackersTrashEmptyPost(params, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type EmptyTrashApiTrackersTrashEmptyPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof emptyTrashApiTrackersTrashEmptyPost>>
>;

export type EmptyTrashApiTrackersTrashEmptyPostMutationError = HTTPValidationError;

/**
 * @summary Empty Trash
 */
export const createEmptyTrashApiTrackersTrashEmptyPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof emptyTrashApiTrackersTrashEmptyPost>>,
			TError,
			{ params?: EmptyTrashApiTrackersTrashEmptyPostParams },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof emptyTrashApiTrackersTrashEmptyPost>>,
	TError,
	{ params?: EmptyTrashApiTrackersTrashEmptyPostParams },
	TContext
> => {
	const mutationOptions = getEmptyTrashApiTrackersTrashEmptyPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Set or update tracker schedule. Creates a new schedule if none exists,
otherwise updates the existing one.
 * @summary Set Tracker Schedule
 */
export const setTrackerScheduleApiTrackersTrackerIdSchedulePut = (
	trackerId: string,
	scheduleCreate: ScheduleCreate,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<ScheduleRead>(
		{
			url: `/api/trackers/${trackerId}/schedule`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: scheduleCreate
		},
		options
	);
};

export const getSetTrackerScheduleApiTrackersTrackerIdSchedulePutMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof setTrackerScheduleApiTrackersTrackerIdSchedulePut>>,
		TError,
		{ trackerId: string; data: ScheduleCreate },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof setTrackerScheduleApiTrackersTrackerIdSchedulePut>>,
	TError,
	{ trackerId: string; data: ScheduleCreate },
	TContext
> => {
	const mutationKey = ['setTrackerScheduleApiTrackersTrackerIdSchedulePut'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof setTrackerScheduleApiTrackersTrackerIdSchedulePut>>,
		{ trackerId: string; data: ScheduleCreate }
	> = (props) => {
		const { trackerId, data } = props ?? {};

		return setTrackerScheduleApiTrackersTrackerIdSchedulePut(trackerId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type SetTrackerScheduleApiTrackersTrackerIdSchedulePutMutationResult = NonNullable<
	Awaited<ReturnType<typeof setTrackerScheduleApiTrackersTrackerIdSchedulePut>>
>;
export type SetTrackerScheduleApiTrackersTrackerIdSchedulePutMutationBody = ScheduleCreate;
export type SetTrackerScheduleApiTrackersTrackerIdSchedulePutMutationError = HTTPValidationError;

/**
 * @summary Set Tracker Schedule
 */
export const createSetTrackerScheduleApiTrackersTrackerIdSchedulePut = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof setTrackerScheduleApiTrackersTrackerIdSchedulePut>>,
			TError,
			{ trackerId: string; data: ScheduleCreate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof setTrackerScheduleApiTrackersTrackerIdSchedulePut>>,
	TError,
	{ trackerId: string; data: ScheduleCreate },
	TContext
> => {
	const mutationOptions =
		getSetTrackerScheduleApiTrackersTrackerIdSchedulePutMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Remove tracker schedule (excludes tracker from Today view).
Idempotent — returns 204 even if no schedule exists.
 * @summary Delete Tracker Schedule
 */
export const deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<void>(
		{ url: `/api/trackers/${trackerId}/schedule`, method: 'DELETE' },
		options
	);
};

export const getDeleteTrackerScheduleApiTrackersTrackerIdScheduleDeleteMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete>>,
		TError,
		{ trackerId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationKey = ['deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete>>,
		{ trackerId: string }
	> = (props) => {
		const { trackerId } = props ?? {};

		return deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete(trackerId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteTrackerScheduleApiTrackersTrackerIdScheduleDeleteMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete>>
>;

export type DeleteTrackerScheduleApiTrackersTrackerIdScheduleDeleteMutationError =
	HTTPValidationError;

/**
 * @summary Delete Tracker Schedule
 */
export const createDeleteTrackerScheduleApiTrackersTrackerIdScheduleDelete = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete>>,
			TError,
			{ trackerId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof deleteTrackerScheduleApiTrackersTrackerIdScheduleDelete>>,
	TError,
	{ trackerId: string },
	TContext
> => {
	const mutationOptions =
		getDeleteTrackerScheduleApiTrackersTrackerIdScheduleDeleteMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Check if tracker has any entries.
Used to determine which metric fields can be edited.
 * @summary Check Tracker Has Entries
 */
export const checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet = (
	trackerId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<HasEntriesResponse>(
		{ url: `/api/trackers/${trackerId}/has-entries`, method: 'GET', signal },
		options
	);
};

export const getCheckTrackerHasEntriesApiTrackersTrackerIdHasEntriesGetQueryKey = (
	trackerId?: string
) => {
	return [`/api/trackers/${trackerId}/has-entries`] as const;
};

export const getCheckTrackerHasEntriesApiTrackersTrackerIdHasEntriesGetQueryOptions = <
	TData = Awaited<ReturnType<typeof checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getCheckTrackerHasEntriesApiTrackersTrackerIdHasEntriesGetQueryKey(trackerId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet>>
	> = ({ signal }) =>
		checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet(trackerId, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!trackerId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckTrackerHasEntriesApiTrackersTrackerIdHasEntriesGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet>>
>;
export type CheckTrackerHasEntriesApiTrackersTrackerIdHasEntriesGetQueryError = HTTPValidationError;

/**
 * @summary Check Tracker Has Entries
 */

export function createCheckTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet<
	TData = Awaited<ReturnType<typeof checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet>>,
	TError = HTTPValidationError
>(
	trackerId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof checkTrackerHasEntriesApiTrackersTrackerIdHasEntriesGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getCheckTrackerHasEntriesApiTrackersTrackerIdHasEntriesGetQueryOptions(
		trackerId,
		options
	);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Add new metric to existing tracker.
 * @summary Add Metric To Tracker
 */
export const addMetricToTrackerApiTrackersTrackerIdMetricsPost = (
	trackerId: string,
	metricCreate: MetricCreate,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<MetricRead>(
		{
			url: `/api/trackers/${trackerId}/metrics`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: metricCreate,
			signal
		},
		options
	);
};

export const getAddMetricToTrackerApiTrackersTrackerIdMetricsPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof addMetricToTrackerApiTrackersTrackerIdMetricsPost>>,
		TError,
		{ trackerId: string; data: MetricCreate },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof addMetricToTrackerApiTrackersTrackerIdMetricsPost>>,
	TError,
	{ trackerId: string; data: MetricCreate },
	TContext
> => {
	const mutationKey = ['addMetricToTrackerApiTrackersTrackerIdMetricsPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof addMetricToTrackerApiTrackersTrackerIdMetricsPost>>,
		{ trackerId: string; data: MetricCreate }
	> = (props) => {
		const { trackerId, data } = props ?? {};

		return addMetricToTrackerApiTrackersTrackerIdMetricsPost(trackerId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AddMetricToTrackerApiTrackersTrackerIdMetricsPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof addMetricToTrackerApiTrackersTrackerIdMetricsPost>>
>;
export type AddMetricToTrackerApiTrackersTrackerIdMetricsPostMutationBody = MetricCreate;
export type AddMetricToTrackerApiTrackersTrackerIdMetricsPostMutationError = HTTPValidationError;

/**
 * @summary Add Metric To Tracker
 */
export const createAddMetricToTrackerApiTrackersTrackerIdMetricsPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof addMetricToTrackerApiTrackersTrackerIdMetricsPost>>,
			TError,
			{ trackerId: string; data: MetricCreate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof addMetricToTrackerApiTrackersTrackerIdMetricsPost>>,
	TError,
	{ trackerId: string; data: MetricCreate },
	TContext
> => {
	const mutationOptions =
		getAddMetricToTrackerApiTrackersTrackerIdMetricsPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Update metric with validation.

samlla#v757: metric_type, scale bounds, and removing an existing Select
option are refused once the metric has recorded entry values (409) — the
same rule the MCP update_metric tool already enforces. name/unit/
description/tracking_mode/default_statistic/adding or renaming Select
options/is_active remain editable regardless of history.
 * @summary Update Metric
 */
export const updateMetricApiTrackersTrackerIdMetricsMetricIdPatch = (
	trackerId: string,
	metricId: string,
	metricUpdate: MetricUpdate,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<MetricRead>(
		{
			url: `/api/trackers/${trackerId}/metrics/${metricId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: metricUpdate
		},
		options
	);
};

export const getUpdateMetricApiTrackersTrackerIdMetricsMetricIdPatchMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof updateMetricApiTrackersTrackerIdMetricsMetricIdPatch>>,
		TError,
		{ trackerId: string; metricId: string; data: MetricUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof updateMetricApiTrackersTrackerIdMetricsMetricIdPatch>>,
	TError,
	{ trackerId: string; metricId: string; data: MetricUpdate },
	TContext
> => {
	const mutationKey = ['updateMetricApiTrackersTrackerIdMetricsMetricIdPatch'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateMetricApiTrackersTrackerIdMetricsMetricIdPatch>>,
		{ trackerId: string; metricId: string; data: MetricUpdate }
	> = (props) => {
		const { trackerId, metricId, data } = props ?? {};

		return updateMetricApiTrackersTrackerIdMetricsMetricIdPatch(
			trackerId,
			metricId,
			data,
			requestOptions
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateMetricApiTrackersTrackerIdMetricsMetricIdPatchMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateMetricApiTrackersTrackerIdMetricsMetricIdPatch>>
>;
export type UpdateMetricApiTrackersTrackerIdMetricsMetricIdPatchMutationBody = MetricUpdate;
export type UpdateMetricApiTrackersTrackerIdMetricsMetricIdPatchMutationError = HTTPValidationError;

/**
 * @summary Update Metric
 */
export const createUpdateMetricApiTrackersTrackerIdMetricsMetricIdPatch = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof updateMetricApiTrackersTrackerIdMetricsMetricIdPatch>>,
			TError,
			{ trackerId: string; metricId: string; data: MetricUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof updateMetricApiTrackersTrackerIdMetricsMetricIdPatch>>,
	TError,
	{ trackerId: string; metricId: string; data: MetricUpdate },
	TContext
> => {
	const mutationOptions =
		getUpdateMetricApiTrackersTrackerIdMetricsMetricIdPatchMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Delete metric and all associated data.
Warning: This will cascade delete all entry_values for this metric.
 * @summary Delete Metric
 */
export const deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete = (
	trackerId: string,
	metricId: string,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<void>(
		{ url: `/api/trackers/${trackerId}/metrics/${metricId}`, method: 'DELETE' },
		options
	);
};

export const getDeleteMetricApiTrackersTrackerIdMetricsMetricIdDeleteMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete>>,
		TError,
		{ trackerId: string; metricId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete>>,
	TError,
	{ trackerId: string; metricId: string },
	TContext
> => {
	const mutationKey = ['deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete>>,
		{ trackerId: string; metricId: string }
	> = (props) => {
		const { trackerId, metricId } = props ?? {};

		return deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete(
			trackerId,
			metricId,
			requestOptions
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteMetricApiTrackersTrackerIdMetricsMetricIdDeleteMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete>>
>;

export type DeleteMetricApiTrackersTrackerIdMetricsMetricIdDeleteMutationError =
	HTTPValidationError;

/**
 * @summary Delete Metric
 */
export const createDeleteMetricApiTrackersTrackerIdMetricsMetricIdDelete = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete>>,
			TError,
			{ trackerId: string; metricId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof deleteMetricApiTrackersTrackerIdMetricsMetricIdDelete>>,
	TError,
	{ trackerId: string; metricId: string },
	TContext
> => {
	const mutationOptions =
		getDeleteMetricApiTrackersTrackerIdMetricsMetricIdDeleteMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * List all pinned unit conversions for a metric (ordered by order_index).
 * @summary List Metric Conversions
 */
export const listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet = (
	trackerId: string,
	metricId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UnitConversionRead[]>(
		{ url: `/api/trackers/${trackerId}/metrics/${metricId}/conversions`, method: 'GET', signal },
		options
	);
};

export const getListMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGetQueryKey = (
	trackerId?: string,
	metricId?: string
) => {
	return [`/api/trackers/${trackerId}/metrics/${metricId}/conversions`] as const;
};

export const getListMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGetQueryOptions =
	<
		TData = Awaited<
			ReturnType<typeof listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet>
		>,
		TError = HTTPValidationError
	>(
		trackerId: string,
		metricId: string,
		options?: {
			query?: Partial<
				CreateQueryOptions<
					Awaited<
						ReturnType<
							typeof listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet
						>
					>,
					TError,
					TData
				>
			>;
			request?: SecondParameter<typeof customInstance>;
		}
	) => {
		const { query: queryOptions, request: requestOptions } = options ?? {};

		const queryKey =
			queryOptions?.queryKey ??
			getListMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGetQueryKey(
				trackerId,
				metricId
			);

		const queryFn: QueryFunction<
			Awaited<
				ReturnType<typeof listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet>
			>
		> = ({ signal }) =>
			listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet(
				trackerId,
				metricId,
				requestOptions,
				signal
			);

		return {
			queryKey,
			queryFn,
			enabled: !!(trackerId && metricId),
			...queryOptions
		} as CreateQueryOptions<
			Awaited<
				ReturnType<typeof listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet>
			>,
			TError,
			TData
		> & { queryKey: DataTag<QueryKey, TData, TError> };
	};

export type ListMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGetQueryResult =
	NonNullable<
		Awaited<
			ReturnType<typeof listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet>
		>
	>;
export type ListMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGetQueryError =
	HTTPValidationError;

/**
 * @summary List Metric Conversions
 */

export function createListMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet<
	TData = Awaited<
		ReturnType<typeof listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet>
	>,
	TError = HTTPValidationError
>(
	trackerId: string,
	metricId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<
					ReturnType<typeof listMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGet>
				>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions =
		getListMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsGetQueryOptions(
			trackerId,
			metricId,
			options
		);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Pin a new unit conversion to a metric.
 * @summary Create Metric Conversion
 */
export const createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost = (
	trackerId: string,
	metricId: string,
	unitConversionCreate: UnitConversionCreate,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UnitConversionRead>(
		{
			url: `/api/trackers/${trackerId}/metrics/${metricId}/conversions`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: unitConversionCreate,
			signal
		},
		options
	);
};

export const getCreateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPostMutationOptions =
	<TError = HTTPValidationError, TContext = unknown>(options?: {
		mutation?: CreateMutationOptions<
			Awaited<
				ReturnType<typeof createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost>
			>,
			TError,
			{ trackerId: string; metricId: string; data: UnitConversionCreate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): CreateMutationOptions<
		Awaited<
			ReturnType<typeof createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost>
		>,
		TError,
		{ trackerId: string; metricId: string; data: UnitConversionCreate },
		TContext
	> => {
		const mutationKey = [
			'createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost'
		];
		const { mutation: mutationOptions, request: requestOptions } = options
			? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
				? options
				: { ...options, mutation: { ...options.mutation, mutationKey } }
			: { mutation: { mutationKey }, request: undefined };

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<typeof createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost>
			>,
			{ trackerId: string; metricId: string; data: UnitConversionCreate }
		> = (props) => {
			const { trackerId, metricId, data } = props ?? {};

			return createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost(
				trackerId,
				metricId,
				data,
				requestOptions
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type CreateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPostMutationResult =
	NonNullable<
		Awaited<
			ReturnType<typeof createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost>
		>
	>;
export type CreateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPostMutationBody =
	UnitConversionCreate;
export type CreateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPostMutationError =
	HTTPValidationError;

/**
 * @summary Create Metric Conversion
 */
export const createCreateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<
				ReturnType<typeof createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost>
			>,
			TError,
			{ trackerId: string; metricId: string; data: UnitConversionCreate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<
		ReturnType<typeof createMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPost>
	>,
	TError,
	{ trackerId: string; metricId: string; data: UnitConversionCreate },
	TContext
> => {
	const mutationOptions =
		getCreateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsPostMutationOptions(
			options
		);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Reorder a metric's conversions. Body carries the FULL id set in target order.
 * @summary Reorder Metric Conversions
 */
export const reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut = (
	trackerId: string,
	metricId: string,
	unitConversionReorderRequest: UnitConversionReorderRequest,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<UnitConversionRead[]>(
		{
			url: `/api/trackers/${trackerId}/metrics/${metricId}/conversions/reorder`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: unitConversionReorderRequest
		},
		options
	);
};

export const getReorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPutMutationOptions =
	<TError = HTTPValidationError, TContext = unknown>(options?: {
		mutation?: CreateMutationOptions<
			Awaited<
				ReturnType<
					typeof reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut
				>
			>,
			TError,
			{ trackerId: string; metricId: string; data: UnitConversionReorderRequest },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): CreateMutationOptions<
		Awaited<
			ReturnType<
				typeof reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut
			>
		>,
		TError,
		{ trackerId: string; metricId: string; data: UnitConversionReorderRequest },
		TContext
	> => {
		const mutationKey = [
			'reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut'
		];
		const { mutation: mutationOptions, request: requestOptions } = options
			? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
				? options
				: { ...options, mutation: { ...options.mutation, mutationKey } }
			: { mutation: { mutationKey }, request: undefined };

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<
					typeof reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut
				>
			>,
			{ trackerId: string; metricId: string; data: UnitConversionReorderRequest }
		> = (props) => {
			const { trackerId, metricId, data } = props ?? {};

			return reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut(
				trackerId,
				metricId,
				data,
				requestOptions
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type ReorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPutMutationResult =
	NonNullable<
		Awaited<
			ReturnType<
				typeof reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut
			>
		>
	>;
export type ReorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPutMutationBody =
	UnitConversionReorderRequest;
export type ReorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPutMutationError =
	HTTPValidationError;

/**
 * @summary Reorder Metric Conversions
 */
export const createReorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut =
	<TError = HTTPValidationError, TContext = unknown>(
		options?: {
			mutation?: CreateMutationOptions<
				Awaited<
					ReturnType<
						typeof reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut
					>
				>,
				TError,
				{ trackerId: string; metricId: string; data: UnitConversionReorderRequest },
				TContext
			>;
			request?: SecondParameter<typeof customInstance>;
		},
		queryClient?: QueryClient
	): CreateMutationResult<
		Awaited<
			ReturnType<
				typeof reorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPut
			>
		>,
		TError,
		{ trackerId: string; metricId: string; data: UnitConversionReorderRequest },
		TContext
	> => {
		const mutationOptions =
			getReorderMetricConversionsApiTrackersTrackerIdMetricsMetricIdConversionsReorderPutMutationOptions(
				options
			);

		return createMutation(() => ({ ...mutationOptions, queryClient }));
	};
/**
 * Update a conversion's target unit and/or factor.
 * @summary Update Metric Conversion
 */
export const updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch =
	(
		trackerId: string,
		metricId: string,
		conversionId: string,
		unitConversionUpdate: UnitConversionUpdate,
		options?: SecondParameter<typeof customInstance>
	) => {
		return customInstance<UnitConversionRead>(
			{
				url: `/api/trackers/${trackerId}/metrics/${metricId}/conversions/${conversionId}`,
				method: 'PATCH',
				headers: { 'Content-Type': 'application/json' },
				data: unitConversionUpdate
			},
			options
		);
	};

export const getUpdateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatchMutationOptions =
	<TError = HTTPValidationError, TContext = unknown>(options?: {
		mutation?: CreateMutationOptions<
			Awaited<
				ReturnType<
					typeof updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch
				>
			>,
			TError,
			{ trackerId: string; metricId: string; conversionId: string; data: UnitConversionUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): CreateMutationOptions<
		Awaited<
			ReturnType<
				typeof updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch
			>
		>,
		TError,
		{ trackerId: string; metricId: string; conversionId: string; data: UnitConversionUpdate },
		TContext
	> => {
		const mutationKey = [
			'updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch'
		];
		const { mutation: mutationOptions, request: requestOptions } = options
			? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
				? options
				: { ...options, mutation: { ...options.mutation, mutationKey } }
			: { mutation: { mutationKey }, request: undefined };

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<
					typeof updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch
				>
			>,
			{ trackerId: string; metricId: string; conversionId: string; data: UnitConversionUpdate }
		> = (props) => {
			const { trackerId, metricId, conversionId, data } = props ?? {};

			return updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch(
				trackerId,
				metricId,
				conversionId,
				data,
				requestOptions
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type UpdateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatchMutationResult =
	NonNullable<
		Awaited<
			ReturnType<
				typeof updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch
			>
		>
	>;
export type UpdateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatchMutationBody =
	UnitConversionUpdate;
export type UpdateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatchMutationError =
	HTTPValidationError;

/**
 * @summary Update Metric Conversion
 */
export const createUpdateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch =
	<TError = HTTPValidationError, TContext = unknown>(
		options?: {
			mutation?: CreateMutationOptions<
				Awaited<
					ReturnType<
						typeof updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch
					>
				>,
				TError,
				{ trackerId: string; metricId: string; conversionId: string; data: UnitConversionUpdate },
				TContext
			>;
			request?: SecondParameter<typeof customInstance>;
		},
		queryClient?: QueryClient
	): CreateMutationResult<
		Awaited<
			ReturnType<
				typeof updateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatch
			>
		>,
		TError,
		{ trackerId: string; metricId: string; conversionId: string; data: UnitConversionUpdate },
		TContext
	> => {
		const mutationOptions =
			getUpdateMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdPatchMutationOptions(
				options
			);

		return createMutation(() => ({ ...mutationOptions, queryClient }));
	};
/**
 * Delete a pinned conversion.
 * @summary Delete Metric Conversion
 */
export const deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete =
	(
		trackerId: string,
		metricId: string,
		conversionId: string,
		options?: SecondParameter<typeof customInstance>
	) => {
		return customInstance<void>(
			{
				url: `/api/trackers/${trackerId}/metrics/${metricId}/conversions/${conversionId}`,
				method: 'DELETE'
			},
			options
		);
	};

export const getDeleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDeleteMutationOptions =
	<TError = HTTPValidationError, TContext = unknown>(options?: {
		mutation?: CreateMutationOptions<
			Awaited<
				ReturnType<
					typeof deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete
				>
			>,
			TError,
			{ trackerId: string; metricId: string; conversionId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	}): CreateMutationOptions<
		Awaited<
			ReturnType<
				typeof deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete
			>
		>,
		TError,
		{ trackerId: string; metricId: string; conversionId: string },
		TContext
	> => {
		const mutationKey = [
			'deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete'
		];
		const { mutation: mutationOptions, request: requestOptions } = options
			? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
				? options
				: { ...options, mutation: { ...options.mutation, mutationKey } }
			: { mutation: { mutationKey }, request: undefined };

		const mutationFn: MutationFunction<
			Awaited<
				ReturnType<
					typeof deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete
				>
			>,
			{ trackerId: string; metricId: string; conversionId: string }
		> = (props) => {
			const { trackerId, metricId, conversionId } = props ?? {};

			return deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete(
				trackerId,
				metricId,
				conversionId,
				requestOptions
			);
		};

		return { mutationFn, ...mutationOptions };
	};

export type DeleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDeleteMutationResult =
	NonNullable<
		Awaited<
			ReturnType<
				typeof deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete
			>
		>
	>;

export type DeleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDeleteMutationError =
	HTTPValidationError;

/**
 * @summary Delete Metric Conversion
 */
export const createDeleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete =
	<TError = HTTPValidationError, TContext = unknown>(
		options?: {
			mutation?: CreateMutationOptions<
				Awaited<
					ReturnType<
						typeof deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete
					>
				>,
				TError,
				{ trackerId: string; metricId: string; conversionId: string },
				TContext
			>;
			request?: SecondParameter<typeof customInstance>;
		},
		queryClient?: QueryClient
	): CreateMutationResult<
		Awaited<
			ReturnType<
				typeof deleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDelete
			>
		>,
		TError,
		{ trackerId: string; metricId: string; conversionId: string },
		TContext
	> => {
		const mutationOptions =
			getDeleteMetricConversionApiTrackersTrackerIdMetricsMetricIdConversionsConversionIdDeleteMutationOptions(
				options
			);

		return createMutation(() => ({ ...mutationOptions, queryClient }));
	};
/**
 * Cross-window AI summary for the tracker's 'Where I am' tab (SAM-812).
 * @summary Generate Baseline Summary
 */
export const generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost = (
	trackerId: string,
	params?: GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<BaselineSummaryResponse>(
		{ url: `/api/trackers/${trackerId}/baseline/summary`, method: 'POST', params, signal },
		options
	);
};

export const getGenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost>>,
		TError,
		{
			trackerId: string;
			params?: GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost>>,
	TError,
	{
		trackerId: string;
		params?: GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostParams;
	},
	TContext
> => {
	const mutationKey = ['generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost>>,
		{
			trackerId: string;
			params?: GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostParams;
		}
	> = (props) => {
		const { trackerId, params } = props ?? {};

		return generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost(
			trackerId,
			params,
			requestOptions
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost>>
	>;

export type GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostMutationError =
	HTTPValidationError;

/**
 * @summary Generate Baseline Summary
 */
export const createGenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost>>,
			TError,
			{
				trackerId: string;
				params?: GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostParams;
			},
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof generateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPost>>,
	TError,
	{
		trackerId: string;
		params?: GenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostParams;
	},
	TContext
> => {
	const mutationOptions =
		getGenerateBaselineSummaryApiTrackersTrackerIdBaselineSummaryPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
